import { useEffect, useState } from 'react';

interface VersionInfo {
  commitSha: string;
  builtAt: string;
}

export function DebugFooter() {
  const [info, setInfo] = useState<VersionInfo | null>(null);

  useEffect(() => {
    fetch('/version.json')
      .then((res) => {
        if (!res.ok) return;
        return res.json() as Promise<VersionInfo>;
      })
      .then((data) => {
        if (data) setInfo(data);
      })
      .catch(() => {
        // Failure means broken deploy — not a user concern. Stay hidden.
      });
  }, []);

  if (!info) {
    return (
      <div
        data-testid="debug-footer"
        style={{ display: 'none' }}
        aria-hidden="true"
      />
    );
  }

  const sha7 = info.commitSha.slice(0, 7);
  const builtAtDisplay = info.builtAt.slice(0, 10);

  return (
    <div
      data-testid="debug-footer"
      className="text-[10px] text-text-muted text-center py-1 select-none"
    >
      BUILD-{sha7} @ {builtAtDisplay}
    </div>
  );
}
